(() => {
  const normalize = (value) => String(value || '').toLowerCase();
  const sizeRoot = document.querySelector('[data-size-filter]');
  const buttons = [...document.querySelectorAll('[data-size]')];
  const cards = [...document.querySelectorAll('[data-product-card]')];
  const empty = document.querySelector('[data-no-results]');
  let selected = null;

  function applySize(size) {
    selected = selected === size ? null : size;
    buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.size === selected)));
    let visible = 0;
    cards.forEach((card) => {
      const match = !selected || normalize(card.dataset.sizes).includes(selected);
      card.hidden = !match;
      if (match) visible += 1;
    });
    if (empty) empty.hidden = visible !== 0;
  }

  buttons.forEach((button) => button.addEventListener('click', () => {
    if (button.dataset.sizeUrl) {
      window.location.assign(button.dataset.sizeUrl);
      return;
    }
    applySize(button.dataset.size);
  }));
  if (sizeRoot) {
    sizeRoot.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      const index = buttons.indexOf(document.activeElement);
      if (index < 0) return;
      event.preventDefault();
      buttons[(index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length].focus();
    });
  }

  const drawer = document.querySelector('[data-menu-drawer]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const overlay = document.querySelector('.menu-overlay');
  const menuCloseButtons = [...document.querySelectorAll('[data-menu-close]')];
  let lastFocused = null;

  const closeDrawer = () => {
    if (!drawer || !menuToggle) return;
    drawer.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
    lastFocused?.focus();
  };

  const openDrawer = () => {
    if (!drawer || !menuToggle) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    overlay?.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
    drawer.querySelector('button, a')?.focus();
  };

  menuToggle?.addEventListener('click', openDrawer);
  menuCloseButtons.forEach((button) => button.addEventListener('click', closeDrawer));
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeDrawer));

  document.addEventListener('keydown', (event) => {
    if (!drawer?.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a, button:not([disabled])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.querySelectorAll('[data-hero-slideshow]').forEach((slideshow) => {
    const slides = [...slideshow.querySelectorAll('[data-hero-slide]')];
    const dots = [...slideshow.querySelectorAll('[data-hero-dot]')];
    const previous = slideshow.querySelector('[data-hero-prev]');
    const next = slideshow.querySelector('[data-hero-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer = null;

    const showSlide = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === current)));
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (slides.length < 2 || reduceMotion || slideshow.dataset.autoRotate !== 'true') return;
      const seconds = Math.max(3, Number(slideshow.dataset.interval) || 5);
      timer = window.setInterval(() => showSlide(current + 1), seconds * 1000);
    };

    previous?.addEventListener('click', () => { showSlide(current - 1); start(); });
    next?.addEventListener('click', () => { showSlide(current + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { showSlide(Number(dot.dataset.index)); start(); }));
    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);
    slideshow.addEventListener('focusin', stop);
    slideshow.addEventListener('focusout', (event) => {
      if (!slideshow.contains(event.relatedTarget)) start();
    });
    showSlide(0);
    start();
  });

  document.querySelectorAll('[data-editorial-slideshow]').forEach((slideshow) => {
    const slides = [...slideshow.querySelectorAll('[data-editorial-slide]')];
    const dots = [...slideshow.querySelectorAll('[data-editorial-dot]')];
    const previous = slideshow.querySelector('[data-editorial-prev]');
    const next = slideshow.querySelector('[data-editorial-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer = null;
    let touchStartX = null;

    const showSlide = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === current)));
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (slides.length < 2 || reduceMotion || slideshow.dataset.autoRotate !== 'true') return;
      const seconds = Math.max(3, Number(slideshow.dataset.interval) || 6);
      timer = window.setInterval(() => showSlide(current + 1), seconds * 1000);
    };

    const move = (direction) => {
      showSlide(current + direction);
      start();
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    dots.forEach((dot) => dot.addEventListener('click', () => {
      showSlide(Number(dot.dataset.index));
      start();
    }));
    slideshow.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    });
    slideshow.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
      stop();
    }, { passive: true });
    slideshow.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX ?? null;
      if (touchStartX !== null && touchEndX !== null && Math.abs(touchEndX - touchStartX) > 48) {
        move(touchEndX < touchStartX ? 1 : -1);
      } else {
        start();
      }
      touchStartX = null;
    }, { passive: true });
    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);
    slideshow.addEventListener('focusin', stop);
    slideshow.addEventListener('focusout', (event) => {
      if (!slideshow.contains(event.relatedTarget)) start();
    });
    slideshow.setAttribute('tabindex', '0');
    showSlide(0);
    start();
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('[data-product-form]');
    const price = form?.closest('.product-purchase')?.querySelector('[data-product-main-price]');
    const button = form?.querySelector('[data-add-to-cart]');
    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      }
    };
    select.addEventListener('change', updateVariant);
    updateVariant();
  });

  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-product-carousel-viewport]');
    const slides = [...carousel.querySelectorAll('[data-product-slide]')];
    const dots = [...carousel.querySelectorAll('[data-product-carousel-dot]')];
    const previous = carousel.querySelector('[data-product-carousel-prev]');
    const next = carousel.querySelector('[data-product-carousel-next]');
    if (!viewport || !slides.length) return;
    let current = 0;
    let frame = null;

    const render = (index) => {
      current = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === current)));
      if (previous) previous.disabled = current === 0;
      if (next) next.disabled = current === slides.length - 1;
    };
    const goTo = (index) => {
      const target = Math.max(0, Math.min(index, slides.length - 1));
      viewport.scrollTo({ left: target * viewport.clientWidth, behavior: 'smooth' });
      render(target);
    };

    previous?.addEventListener('click', () => goTo(current - 1));
    next?.addEventListener('click', () => goTo(current + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.index))));
    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
    });
    viewport.addEventListener('scroll', () => {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => render(Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1))));
    }, { passive: true });
    render(0);
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(async (container) => {
    const url = container.dataset.url;
    if (!url) return;
    try {
      const response = await fetch(url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const rendered = html.querySelector('[data-product-recommendations]');
      if (rendered?.children.length) container.innerHTML = rendered.innerHTML;
    } catch (_) {}
  });
})();

(() => {
  const dialog = document.querySelector('[data-favorites-dialog]');
  if (!dialog) return;
  const grid = dialog.querySelector('[data-favorites-grid]');
  const status = dialog.querySelector('[data-favorites-status]');
  const retry = dialog.querySelector('[data-favorites-retry]');
  const root = dialog.dataset.root.replace(/\/?$/, '/');
  let favorites = [];
  let handles = {};
  let generation = 0;
  let opener;
  const read = (key, fallback) => {
    try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch (_) { return fallback; }
  };
  const readFavorites = () => {
    const value = read('ticka-favorites', []);
    return Array.isArray(value) ? [...new Set(value.map(String).filter(id => /^\d+$/.test(id)))] : [];
  };
  favorites = readFavorites();
  const stored = read('ticka-favorite-handles', {});
  if (stored && typeof stored === 'object' && !Array.isArray(stored)) handles = stored;
  const save = () => {
    try {
      localStorage.setItem('ticka-favorites', JSON.stringify(favorites));
      localStorage.setItem('ticka-favorite-handles', JSON.stringify(handles));
    } catch (_) {
      document.querySelector('[data-favorites-notice]').textContent = dialog.dataset.storageError;
    }
  };
  function sync() {
    document.querySelectorAll('[data-favorites-count]').forEach(el => { el.textContent = favorites.length; });
    document.querySelectorAll('[data-favorite]').forEach(button => {
      const active = favorites.includes(button.dataset.favorite);
      const title = button.dataset.favoriteTitle || button.getAttribute('aria-label').replace(/をお気に入りから削除|をお気に入りに追加/g, '');
      button.dataset.favoriteTitle = title;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', title + (active ? dialog.dataset.remove : dialog.dataset.add));
      const icon = button.querySelector('span');
      if (icon) icon.textContent = active ? '♥' : '♡';
      if (button.dataset.favoriteHandle) handles[button.dataset.favorite] = button.dataset.favoriteHandle;
    });
  }
  async function get(url, type) {
    const response = await fetch(url, {signal: AbortSignal.timeout(15000)});
    if (response.status === 404) return null;
    if (!response.ok) throw new Error('load');
    return type === 'json' ? response.json() : response.text();
  }
  async function load() {
    const run = ++generation;
    grid.replaceChildren();
    retry.hidden = true;
    status.textContent = favorites.length ? dialog.dataset.loading : dialog.dataset.empty;
    if (!favorites.length) return;
    const ids = [...favorites].reverse();
    try {
      const unresolved = new Set(ids.filter(id => !handles[id]));
      for (let page = 1; unresolved.size; page++) {
        const data = await get(`${root}products.json?limit=250&page=${page}`, 'json');
        if (run !== generation) return;
        if (!data || !Array.isArray(data.products)) throw new Error('catalog');
        data.products.forEach(product => {
          const id = String(product.id);
          if (unresolved.has(id)) { handles[id] = product.handle; unresolved.delete(id); }
        });
        if (data.products.length < 250) break;
      }
      save();
      let failed = false;
      for (let offset = 0; offset < ids.length; offset += 4) {
        const results = await Promise.allSettled(ids.slice(offset, offset + 4).map(async id => {
          if (!handles[id]) return {id, card: null};
          const html = await get(`${root}products/${encodeURIComponent(handles[id])}?section_id=ticka-favorite-card`, 'text');
          if (html === null) return {id, card: null};
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const card = doc.querySelector('.product-card');
          if (!card || card.querySelector('[data-favorite]')?.dataset.favorite !== id) throw new Error('card');
          return {id, card};
        }));
        if (run !== generation) return;
        results.forEach(result => {
          if (result.status === 'rejected') { failed = true; return; }
          const {id, card} = result.value;
          if (!favorites.includes(id)) return;
          if (card) {
            card.dataset.savedId = id;
            grid.append(card);
          } else {
            const item = document.createElement('article');
            item.className = 'favorites-unavailable';
            item.dataset.savedId = id;
            const text = document.createElement('p');
            text.textContent = dialog.dataset.missing;
            const remove = document.createElement('button');
            remove.type = 'button'; remove.dataset.favorite = id;
            remove.setAttribute('aria-label', dialog.dataset.missing + dialog.dataset.remove);
            remove.textContent = dialog.dataset.remove.replace(/^を/, '');
            item.append(text, remove); grid.append(item);
          }
        });
        sync();
      }
      status.textContent = failed ? dialog.dataset.error : '';
      retry.hidden = !failed;
    } catch (_) {
      if (run !== generation) return;
      status.textContent = dialog.dataset.error;
      retry.hidden = false;
    }
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-favorites-open]');
    if (open) {
      opener = open;
      if (document.body.classList.contains('menu-open')) document.querySelector('[data-menu-close]')?.click();
      dialog.showModal();
      document.body.classList.add('favorites-open');
      load();
      return;
    }
    if (event.target.closest('[data-favorites-close]')) { dialog.close(); return; }
    const button = event.target.closest('[data-favorite]');
    if (!button) return;
    const id = button.dataset.favorite;
    favorites = favorites.includes(id) ? favorites.filter(item => item !== id) : [...favorites, id];
    sync(); save();
    if (dialog.open) {
      const item = button.closest('[data-saved-id]');
      const next = item?.nextElementSibling?.querySelector('button') || item?.previousElementSibling?.querySelector('button');
      item?.remove();
      (next || dialog.querySelector('[data-favorites-close]')).focus();
      if (!favorites.length) { ++generation; status.textContent = dialog.dataset.empty; retry.hidden = true; }
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => { ++generation; document.body.classList.remove('favorites-open'); opener?.focus(); });
  retry.addEventListener('click', load);
  window.addEventListener('storage', event => {
    if (event.key === 'ticka-favorites' || event.key === null) {
      favorites = readFavorites(); sync(); if (dialog.open) load();
    }
  });
  window.addEventListener('pageshow', () => { favorites = readFavorites(); sync(); });
  sync();
})();
